import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './PricingHeader.css';

function PricingHeader() {
    const { t } = useTranslation();

    return (
        <div className='pricing-header' style={{ backgroundImage: 'url(/images/homepage-header.png' }}>
            <div className='page-content d-flex align-items-center'>
                <div className='col-6 d-flex flex-column'>
                    <div className='chip'>
                        {t('Flexible Plans for Every Property')}
                    </div>
                    <h1 className='mt-3'>{t('Prostay Pricing')}</h1>
                    <p className='body-large'>
                        {t('Whether you’re running a boutique hotel, a multi-property resort, or a growing vacation rental brand, you only pay for the modules you use. Choose the tools that match your operations and scale as you grow—no hidden fees, no long-term contracts, just complete control over your plan.')}

                    </p>
                </div>
                <div className='col img-wrapper'>
                    <img className='center-content-img-width' src='/images/pricing.png' alt={"Room planning"}/>
                </div>
            </div>
        </div>
    );
}

export default PricingHeader;
